import React from 'react';

const TimeLeftLabel = ({ className, isEndingSoon, timeLeft }) => {
    return (
        <span
            className={`${className || ''} ${
                isEndingSoon ? 'text-danger' : ''
            }`}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: timeLeft
            }}
            data-item-card-details-time-left=""
        />
    );
};
export default TimeLeftLabel;
